<template>
  <div class="dashboard-container" :class="$route.name">
    <div class="dashboard-main-container">
      <!-- <banner /> -->
      <main-header
        :show-logo="true"
        :firstTourStatus="firstTourStatus"
        :enableAddInvoice="enableAddInvoice"
        @enableAddInvoiceChanged="addInvoiceStatus"
        @firstTourStatusChanged="tourStatus"
      />
      <div
        class="dashboard-content px-3"
        :class="{ 'fixed-header': !getActiveTour }"
      >
        <invoice-guide
          :firstTourStatus="firstTourStatus"
          :enableAddInvoice="enableAddInvoice"
          @enableAddInvoiceChanged="addInvoiceStatus"
          @firstTourStatusChanged="tourStatus"
        />
        <router-view v-if="isExporter"> </router-view>
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import MainHeader from '@/components/MainHeader.vue'
import InvoiceGuide from '@/components/InvoiceGuide.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      currentStep: null,
      firstTourStatus: false,
      enableAddInvoice: false
    }
  },
  mounted() {
    if (!this.$store.getters.user) {
      Cookies.remove('default_auth_token', {
        domain: '.dripcapital.com'
      })
      // remove cookies, localStorage data, vue store data
      this.$store.dispatch('unsetAccountId')
      this.$store.dispatch('unsetLocale')

      this.$router.push({ name: 'login' })
    }

    if (
      this.$store.getters.user &&
      this.$store.getters.user.currentAccount &&
      this.$store.getters.user.currentAccount.role &&
      this.$store.getters.user.currentAccount.role === 'importers'
    ) {
      this.$router.push({ name: 'importerDashboard' })
    }
    if (this.$store.getters.user && this.$store.getters.user.id) {
      this.$mpCreateProfile(this.$store.getters.user)
      this.$mpRegister(this.$store.getters.user)
    }
  },
  methods: {
    tourStatus(value) {
      this.firstTourStatus = value
    },
    current(value) {
      this.currentStep = value
    },
    addInvoiceStatus(value) {
      this.enableAddInvoice = value
    }
  },
  computed: {
    isExporter() {
      return (
        this.$store.state.account.account &&
        this.$store.state.account.account.role === 'exporters'
      )
    },
    ...mapGetters(['getActiveTour'])
  },
  components: {
    MainHeader,
    InvoiceGuide
    // Banner
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables';

.dashboard-container {
  display: flex;

  @media screen {
    min-height: 100vh;
  }
}

.dashboard-main-container {
  position: relative;
  background: white;
  // @include gradient-radial(#f8f8f8, #eee);
  @media screen {
    overflow: auto;
  }
  flex-grow: 1;
  .dashboard-content {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.fixed-header {
  z-index: auto;
  margin-top: 5rem;
}
@include media-breakpoint-down(md) {
  .dashboard-main-container {
    .dashboard-content {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
}
</style>
